import { Head, Link } from "@inertiajs/react"
import { ArrowLeft, CheckCircle2, XCircle, MinusCircle, Users } from "lucide-react"
import { AdminLayout } from "../components/AdminLayout"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"

const statusConfig = {
  pending: { label: "Pending", className: "bg-zinc-400 text-white hover:bg-zinc-400" },
  sending: { label: "Sending", className: "bg-amber-500 text-white hover:bg-amber-500" },
  completed: { label: "Completed", className: "bg-green-500 text-white hover:bg-green-500" },
}

function Stat({ icon: Icon, label, value, color }) {
  return (
    <div className="rounded-lg border border-zinc-200 p-4 text-center">
      <Icon className={`h-5 w-5 mx-auto mb-1 ${color}`} />
      <p className="text-2xl font-bold text-zinc-900 tabular-nums">{value}</p>
      <p className="text-xs text-zinc-500">{label}</p>
    </div>
  )
}

export default function BroadcastShow({ currentUser, broadcast, pendingCount }) {
  const status = statusConfig[broadcast.status] || statusConfig.pending

  return (
    <AdminLayout currentUser={currentUser} pendingCount={pendingCount}>
      <Head title={`${broadcast.subject} - Broadcasts`} />

      <div className="space-y-6 max-w-3xl">
        <div>
          <Link
            href="/app/admin/broadcasts"
            className="inline-flex items-center text-sm text-zinc-500 hover:text-zinc-800"
          >
            <ArrowLeft className="h-4 w-4 mr-1" /> Broadcasts
          </Link>
          <div className="flex items-center gap-3 mt-2">
            <h1 className="text-2xl font-bold text-zinc-900">{broadcast.subject}</h1>
            <Badge className={status.className}>{status.label}</Badge>
          </div>
          <p className="text-zinc-500 mt-1">
            {broadcast.audienceLabel} · sent by {broadcast.senderName}
            {broadcast.createdAt ? ` · ${new Date(broadcast.createdAt).toLocaleString()}` : ""}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <Stat icon={Users} label="Recipients" value={broadcast.recipientsCount} color="text-zinc-500" />
          <Stat icon={CheckCircle2} label="Sent" value={broadcast.sentCount} color="text-green-600" />
          <Stat icon={XCircle} label="Failed" value={broadcast.failedCount} color="text-red-600" />
          <Stat icon={MinusCircle} label="Skipped" value={broadcast.skippedCount} color="text-amber-600" />
        </div>

        <Card className="bg-white border-zinc-200">
          <CardHeader>
            <CardTitle className="text-lg font-display">Message</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="whitespace-pre-wrap text-zinc-700 text-sm leading-relaxed">{broadcast.body}</p>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  )
}
